// removed by extract-text-webpack-plugin
module.exports = {"Container":"notfound__Container__3hpl9","BackgroundContainer":"notfound__BackgroundContainer__QtolY","Background":"notfound__Background__1BxeE","Tagline":"notfound__Tagline__nfI41","Sup":"notfound__Sup__2eiLV","Image":"notfound__Image__2KVAW","Content":"notfound__Content__1B9Ea","Description":"notfound__Description__NXv31","Link":"notfound__Link__257FS"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/NotFound/notfound.css
// module id = 1242
// module chunks = 2